<div class="absolute w-screen h-screen top-0 right-0 z-50 flex flex-col justify-center items-center bg-gray-200 bg-opacity-40 backdrop-blur-sm" *ngIf="isLoading">
    <div class="w-36 h-36">
        <svg class="stroke-2" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
            <style type="text/css">
                .st0 {
                    fill: none;
                    stroke: #006AAA;
                    stroke-miterlimit: 10;
                }
    
                .st1 {
                    fill: #006AAA;
                }
    
                .st2 {
                    fill: none;
                    stroke: #006AAA;
                    stroke-width: 0.75;
                    stroke-miterlimit: 10;
                }
            </style>
            <title>Bal-gif</title>
            <g id="Capa_2">
                <circle class="st0" cx="50" cy="50" r="46.5">
                    <animateTransform accumulate="none" additive="replace" attributeName="transform" attributeType="XML"
                        calcMode="linear" dur="10s" fill="remove" from="0 50 50" repeatCount="indefinite" restart="always"
                        to="360 50 50" type="rotate">
                    </animateTransform>
                </circle>
                <circle class="st1" cx="96.5" cy="50" r="2.5">
                    <animateTransform accumulate="none" additive="replace" attributeName="transform" attributeType="XML"
                        calcMode="linear" dur="2s" fill="remove" from="0 50 50" repeatCount="indefinite" restart="always"
                        to="360 50 50" type="rotate">
                    </animateTransform>
                </circle>
                <circle class="st1" cx="3.5" cy="50" r="2.5">
    
                    <animateTransform accumulate="none" additive="replace" attributeName="transform" attributeType="XML"
                        calcMode="linear" dur="2s" fill="remove" from="0 50 50" repeatCount="indefinite" restart="always"
                        to="360 50 50" type="rotate">
                    </animateTransform>
                </circle>
            </g>
            <g id="Capa_5">
                <path class="st2" d="M17,75.2C5.7,60.3,5.7,39.7,17,24.8" />
                <path class="st2" d="M83,24.8c11.3,14.9,11.3,35.5,0,50.3" />
            </g>
            <g id="Capa_1">
                <path class="st1" d="M67.8,51.2c-1.2-3.6-3.8-5.9-7.2-7.3c-0.4-0.2-0.8-0.3-1.2-0.4c0.5-0.6,1-1.1,1.4-1.8
            c2.1-3.2,2.3-7.2-0.5-10.3c-1.9-2.2-4.7-3.5-7.6-3.4c-4.4,0-8.7,0-13.1,0c-0.3,0-0.6,0-0.9,0c-0.8,0-1.4,0.7-1.4,1.5c0,0,0,0,0,0
            c0,0.8,0.6,1.4,1.3,1.4c0,0,0.1,0,0.1,0H40v21c0,1.4,0,2.9,0,4.3c-0.1,0.6,0.2,1.1,0.7,1.5c0.5,0.3,1.1,0.4,1.5,0.1
            c0.5-0.3,0.9-0.8,0.8-1.4c0-3.3,0-6.5,0-9.8v-0.6h0.6c4,0,8,0,12,0c1.7,0,3.5,0.4,5,1.2c4.2,2.2,5.9,7.3,3.7,11.5
            c0,0.1-0.1,0.1-0.1,0.2c-1.7,3-4.9,4.8-8.4,4.7c-6.4,0.1-9.2,0-15.5,0c-3.1-0.1-5.9,1.5-7.5,4.2C32,69,31.6,70.5,31.6,72
            c0.1-0.1,0.1-0.2,0.2-0.3c0.8-2,2.4-3.7,4.4-4.5c1.4-0.6,3-0.8,4.5-0.8c6.1,0,8.5,0,14.6,0c3.7,0.1,7.2-1.3,9.8-4
            C68.1,59.5,69.1,55.1,67.8,51.2z M56.4,41.9c-1.2,0.7-2.6,1.1-4.1,1.1c-3,0-6,0-9.1,0h-0.2V30.9h0.5c3,0,5.9-0.1,8.9,0
            c2.6-0.1,5.1,1.4,6.3,3.7C60.1,37.3,59,40.5,56.4,41.9z" />
            </g>
        </svg>
    </div>
</div>

<div class="absolute w-screen h-screen top-0 right-0 z-50 flex flex-col justify-center items-center bg-gray-200 bg-opacity-40 backdrop-blur-sm" *ngIf="isLoadingFull">
    <div class="w-36 h-36">
        <svg class="stroke-2" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
            <style type="text/css">
                .st0 {
                    fill: none;
                    stroke: #006AAA;
                    stroke-miterlimit: 10;
                }
    
                .st1 {
                    fill: #006AAA;
                }
    
                .st2 {
                    fill: none;
                    stroke: #006AAA;
                    stroke-width: 0.75;
                    stroke-miterlimit: 10;
                }
            </style>
            <title>Bal-gif</title>
            <g id="Capa_2">
                <circle class="st0" cx="50" cy="50" r="46.5">
                    <animateTransform accumulate="none" additive="replace" attributeName="transform" attributeType="XML"
                        calcMode="linear" dur="10s" fill="remove" from="0 50 50" repeatCount="indefinite" restart="always"
                        to="360 50 50" type="rotate">
                    </animateTransform>
                </circle>
                <circle class="st1" cx="96.5" cy="50" r="2.5">
                    <animateTransform accumulate="none" additive="replace" attributeName="transform" attributeType="XML"
                        calcMode="linear" dur="2s" fill="remove" from="0 50 50" repeatCount="indefinite" restart="always"
                        to="360 50 50" type="rotate">
                    </animateTransform>
                </circle>
                <circle class="st1" cx="3.5" cy="50" r="2.5">
    
                    <animateTransform accumulate="none" additive="replace" attributeName="transform" attributeType="XML"
                        calcMode="linear" dur="2s" fill="remove" from="0 50 50" repeatCount="indefinite" restart="always"
                        to="360 50 50" type="rotate">
                    </animateTransform>
                </circle>
            </g>
            <g id="Capa_5">
                <path class="st2" d="M17,75.2C5.7,60.3,5.7,39.7,17,24.8" />
                <path class="st2" d="M83,24.8c11.3,14.9,11.3,35.5,0,50.3" />
            </g>
            <g id="Capa_1">
                <path class="st1" d="M67.8,51.2c-1.2-3.6-3.8-5.9-7.2-7.3c-0.4-0.2-0.8-0.3-1.2-0.4c0.5-0.6,1-1.1,1.4-1.8
            c2.1-3.2,2.3-7.2-0.5-10.3c-1.9-2.2-4.7-3.5-7.6-3.4c-4.4,0-8.7,0-13.1,0c-0.3,0-0.6,0-0.9,0c-0.8,0-1.4,0.7-1.4,1.5c0,0,0,0,0,0
            c0,0.8,0.6,1.4,1.3,1.4c0,0,0.1,0,0.1,0H40v21c0,1.4,0,2.9,0,4.3c-0.1,0.6,0.2,1.1,0.7,1.5c0.5,0.3,1.1,0.4,1.5,0.1
            c0.5-0.3,0.9-0.8,0.8-1.4c0-3.3,0-6.5,0-9.8v-0.6h0.6c4,0,8,0,12,0c1.7,0,3.5,0.4,5,1.2c4.2,2.2,5.9,7.3,3.7,11.5
            c0,0.1-0.1,0.1-0.1,0.2c-1.7,3-4.9,4.8-8.4,4.7c-6.4,0.1-9.2,0-15.5,0c-3.1-0.1-5.9,1.5-7.5,4.2C32,69,31.6,70.5,31.6,72
            c0.1-0.1,0.1-0.2,0.2-0.3c0.8-2,2.4-3.7,4.4-4.5c1.4-0.6,3-0.8,4.5-0.8c6.1,0,8.5,0,14.6,0c3.7,0.1,7.2-1.3,9.8-4
            C68.1,59.5,69.1,55.1,67.8,51.2z M56.4,41.9c-1.2,0.7-2.6,1.1-4.1,1.1c-3,0-6,0-9.1,0h-0.2V30.9h0.5c3,0,5.9-0.1,8.9,0
            c2.6-0.1,5.1,1.4,6.3,3.7C60.1,37.3,59,40.5,56.4,41.9z" />
            </g>
        </svg>
    </div>
</div>

<!--div *ngIf="isLoadingTask" style="width: 100%;margin: 0px;padding: 20px;position: fixed;bottom: 0px;left: 0px;z-index: 60;background-color: #fff">
    <div class="mb-5">
        <img src="../../assets/images/upload.gif" style="width: 25px; float: left;">
        <h5 style="float:left">SUBIENDO ARCHIVOS...</h5>
    </div>
    <div *ngFor="let upload of uploads">
        <p>Progreso de {{ upload.name }}: {{ upload.progress }}%</p>
        <div class="div-content-progress">
            <div [style.width]="upload.progress | async" class="div-progress"></div>
        </div>
    </div>
</div!-->

<div *ngIf="isLoadingTask" style="width: 100%;margin: 0px;padding: 20px;position: fixed;bottom: 0px;left: 0px;z-index: 60;background-color: #fff">
    <div class="mb-1">
        <img src="../../assets/images/upload.gif" style="width: 25px; float: left;">
        <p style="margin: 0px;font-size: 12px;">SUBIENDO ARCHIVOS...</p>
    </div>
    <div *ngFor="let upload of uploads">
        <p style="font-size: 10px; margin: 0px">Progreso de {{ upload.name }} - {{ upload.progress_show | number:'1.0-0' }}%</p>
        <div class="div-content-progress">
            <div [style.width]="upload.progress" class="div-progress"></div>
        </div>
    </div>
</div>